<template>
    <div>
        <div v-if="orderDetails && !loadingOrderDetails" class="mh-100">
            <h1 class="font-weight-bold ml-5 pl-4 text-center">Thank you for your purchase!</h1>
            <div class="mx-5 px-5 mt-3">
                <div class="row">
                    <div class="col-8">
                        <h6 class="text-muted text-uppercase font-weight-bold">Product</h6>
                    </div>
                    <div class="col-2">
                        <h6 class="text-muted text-uppercase font-weight-bold">Quantity</h6>
                    </div>
                    <div class="col-2 text-uppercase text-right">
                        <h6 class="text-muted text-uppercase font-weight-bold">Total</h6>
                    </div>
                </div>

                <div v-for="item, key in orderDetails.line_items.data" :key="key" class="row mt-2 cart-item py-4">
                    <div class="col-8 flex-col">
                        <h4>{{ item.description }}</h4>
                        <span>
                            {{ toCurrency(item.price.unit_amount / 100, item.price.currency) }}
                        </span>
                        <br />
                        <span>{{ item.price.nickname }}</span>
                    </div>
                    <div class="col-2 text-center">
                        <div>
                            <div class="input-group d-flex justify-content-start">
                                <span class="d-flex align-items-center">
                                    {{ item.quantity }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-2 text-uppercase text-right text-bold">
                        {{ toCurrency(item.amount_total / 100, item.price.currency) }}
                    </div>
                </div>
            </div>

            <div class="total d-flex justify-content-end  mx-5 px-5">
                <div class="w-25 d-flex justify-content-between">
                    <span>
                        Total
                    </span>
                    <span>
                        {{
                            toCurrency(orderDetails.amount_total / 100, orderDetails.currency) }}
                    </span>
                </div>
            </div>

            <div v-if="!loadingUserDetails" class="d-flex justify-content-end  mx-5 px-5 mt-3">
                <router-link v-if="isAuth" class="mt-3 text-light" to="/dashboard">
                    Continue to
                    dashboard
                </router-link>

                <div v-if="!isAuth">
                    <span v-if="existingUser">
                        Login account <em>({{ orderDetails.customer_details.email }})</em> <router-link
                            class="mt-3 text-light text-underline" to="/dashboard">
                            here
                        </router-link>
                    </span>

                    <span v-else>
                        You have not created an account <em>({{ orderDetails.customer_details.email }})</em> yet. Click
                        <router-link class="mt-3 text-light text-underline"
                            :to="`/createAccount?username=${orderDetails.customer_details.email}`">
                            here
                        </router-link> to register.
                    </span>
                </div>
            </div>

            <div v-if="loadingUserDetails" class="d-flex justify-content-end  mx-5 px-5 mt-3">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>

        <div v-if="loadingOrderDetails" class="container w-100 py-5 my-5 d-flex justify-content-center">
            <span class="loader"></span>
        </div>
    </div>
</template>

<script>
import {
    getCheckoutSession
} from '../services/stripe.service'
import {
    userAlreadyExists
} from '../services/user.service'
import {
    toCurrency
} from '../utils/currency'

export default {
    data() {
        return {
            isAuth: null,
            existingUser: false,
            orderDetails: null,
            loadingOrderDetails: true,
            loadingUserDetails: true
        };
    },
    mounted() {
        const { checkout } = this.$route.query;

        if (checkout) {
            getCheckoutSession(checkout)
                .then(r => {
                    this.orderDetails = r.data;
                    // check if email exists
                    userAlreadyExists(this.orderDetails.customer_details.email)
                        .then(r => {
                            this.isAuth = localStorage.getItem(
                                'jwt'
                            )
                            this.existingUser = r.data.exists
                        })
                        .catch(err => {
                            // @TODO: handle error
                            console.log(err);
                        })
                        .finally(() => {
                            this.loadingUserDetails = false
                        })
                })
                .catch(err => {
                    // @TODO: handle error
                    console.error(err)
                })
                .finally(() => {
                    this.loadingOrderDetails = false
                });
        }
    },
    methods: {
        toCurrency,
    },
}
</script>

<style lang="scss" scoped>
.cart-item {
    border-top: 0.5px solid rgba(155, 146, 146, 0.637);
}

.loader {
    width: 48px;
    height: 48px;
    display: inline-block;
    position: relative;
}

.loader::after,
.loader::before {
    content: '';
    box-sizing: border-box;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 2px solid #FFF;
    position: absolute;
    left: 0;
    top: 0;
    animation: animloader 2s linear infinite;
}

.loader::after {
    animation-delay: 1s;
}

@keyframes animloader {
    0% {
        transform: scale(0);
        opacity: 1;
    }

    100% {
        transform: scale(1);
        opacity: 0;
    }
}
</style>